import { type Thread } from "../../types";

export type ServerThreadStatus = "ready" | "loading" | "hydrating" | "missing";

export function deriveHydratedServerThreadStatus(input: {
  readonly routeKind: "server" | "draft";
  readonly serverThread: Thread | undefined;
  readonly detailHydrated: boolean;
  readonly subscriptionError: unknown;
}): ServerThreadStatus {
  if (input.routeKind !== "server") return "ready";
  if (input.serverThread === undefined) {
    return input.subscriptionError === undefined ? "loading" : "missing";
  }
  if (input.subscriptionError !== undefined) return "missing";
  return input.detailHydrated ? "ready" : "hydrating";
}
